// extracted by mini-css-extract-plugin
export default {"root":"TermsOfService_root__3K7t0","header":"TermsOfService_header__FLEag","body":"TermsOfService_body__mBSWb"};